import { useCallback } from 'react';
import { useCampaignEditorContext } from 'sections/onsite-campaigns/pages/CampaignEditor/contexts/CampaignEditorContext';

export const useSetDefaultVariant = () => {
  const { dispatch } = useCampaignEditorContext();

  return useCallback(
    (payload: { id: string; variantMessageId: string }) => {
      dispatch({
        type: 'SET_DEFAULT_VARIANT',
        payload,
      });
    },
    [dispatch],
  );
};
